module.exports = __webpack_public_path__ + "img/bottom-hero.bb93c27c.png";